export default "__VITE_ASSET__$JyNHMdk__"